import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { logOut } from "../../../utils/logOut"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function Partner() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    //get URL params
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const type: string | null = params.get('type')

    const { showSnackbar } = useSnackbar();


    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit partner` : 'Add partner'))
    }, [dispatch]);

    //handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    //get partner by ID
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setPartnerData(response.data[0])
            }

            console.log(response.data[0]);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }
    //create partner
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/partner`, {
                address: data.address,
                isactive: data.isactive,
                partnerbankcode: data.partnerbankcode,
                partnerbankname: data.partnerbankname,
                tariffication: data.tariffication,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }
    //edit partner
    async function putData(data: object = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/partner/${id}`, {
                ...data
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    const [partnerData, setPartnerData] = useState<any>(type === 'edit' ? [] :
        {
            "isactive": "1",
            "address": null,
            "partnerbankcode": null,
            "partnerbankname": null,
            "tariffication": "minute"
        }
    )
    //If url params contains type = edit, get partner data to fill text fields
    useEffect(() => {
        type === 'edit' && fetchData()
    }, [])

    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
            <Box>
                <Box sx={{ width: 220, display: "flex", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <TextField error={partnerData.partnerbankcode === null} onChange={(e) => setPartnerData({ ...partnerData, partnerbankcode: e.target.value !== '' ? e.target.value : null })} value={partnerData.partnerbankcode || ''} variant="outlined" size="small" label='Partner bank code*' />
                    <TextField error={partnerData.partnerbankname === null} onChange={(e) => setPartnerData({ ...partnerData, partnerbankname: e.target.value !== '' ? e.target.value : null })} value={partnerData.partnerbankname || ''} variant="outlined" size="small" label='Partner bank name*' />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label">Is active</InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setPartnerData({ ...partnerData, isactive: e.target.value !== '' ? e.target.value : null })} value={partnerData.isactive || ''} variant="outlined" size="small" label='Is active' >
                            <MenuItem value={"1"}>Active</MenuItem>
                            <MenuItem value={"0"}>Not active</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField onChange={(e) => setPartnerData({ ...partnerData, address: e.target.value !== '' ? e.target.value : null })} value={partnerData.address || ''} variant="outlined" size="small" label='Address' />
                    <FormControl>
                        <InputLabel size="small" id="simple-select-label">Tariffication</InputLabel>
                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e) => setPartnerData({ ...partnerData, tariffication: e.target.value !== '' ? e.target.value : null })} value={partnerData.tariffication || ''} variant="outlined" size="small" label='Tariffication' >
                            <MenuItem value={"minute"}>Minute</MenuItem>
                            <MenuItem value={"second"}>Second</MenuItem>
                            <MenuItem value={"15 seconds"}>15 seconds</MenuItem>
                            <MenuItem value={"15 seconds - aon"}>15 seconds - aon</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <Button onClick={() => type === "edit" ? putData(partnerData) : postData(partnerData)} variant="contained" sx={{ width: "100%" }}>Save</Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to='/partners' />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        Saving error
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        Successfully saved
                    </Alert>}
            </Snackbar>
        </Box >
    )
}